import React, { useState } from 'react';
import { Grid, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ColumnDef } from '@tanstack/table-core';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { Header, TableComponent } from '../../../../pricing-simulator/types/generic-table.model';
import { deleteSelectedScenarios } from '../../../../cluster-summary/store/cluster-summary-slice';
import {
  DialogResult,
  AlertDialog
} from 'src/components/analytics';

interface RowData {
  scenario_id?: number;
  [key: string]: any;
}

const DeleteCell = ({ row }: { row: any }) => {
  const appDispatch = useAppDispatch();
  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const { selectedSourceKey } = useAppSelector(
    (state: any) => state.clusterSummary
  );
  const scenarioId = row.original.scenario_id;
  const handleDeleteScenario = (): void => {
    setConfirmationDialogOpen(true);
  };
  const handleConfirmationDialogClose = (result: DialogResult) => {
    if (result === DialogResult.YES) {
      appDispatch(
        deleteSelectedScenarios({
          scenarioIds: [scenarioId],
          sourceId: selectedSourceKey,
        })
      );
    }
    setConfirmationDialogOpen(false);
  };
  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ width: '100%', height: '100%' }}
      >
        <Grid
          item
          style={{
            width: '40px',
            minWidth: '40px',
            maxWidth: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={handleDeleteScenario}
            size="small"
            style={{ padding: '4px' }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
      <AlertDialog
        closeHandler={handleConfirmationDialogClose}
        isDialogOpen={isConfirmationDialogOpen}
        message="Are you sure you want to delete the selected scenarios?"
        title="Info"
      />
    </>
  );
};
export default function getDeleteColumn(
  columnData: Header,
  componentType: TableComponent
) {
  const subHeader: ColumnDef<RowData> = {
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order.toString(),
    header: () => 'Delete',
    accessorKey: 'delete',
    meta: {
      className: 'delete-column',
    },
    cell: ({ row }) => <DeleteCell row={row} />,
  };
  return subHeader;
}